"use strict";
import React from "react";
import FormsyFields from "./formsyFields";
import Formsy from "./formsy";
import PrismIcon from "./prism/icon/prismIcon";
import PrismMessage from "./prism/message/prismMessage";
import { Link } from "react-router-dom";

const {
    LaddaButton
} = flex.lib;

const initComponent = (flex = window.flex) => {
    class ForgotPassword extends React.PureComponent {
        state = {
            canSubmit: false,
            alertMsg: "",
            inputUsername: "",
            username: "",
            isPristine: true,
            securityQuestion1: "",
            securityQuestion2: "",
            inputAnswer1: "",
            inputAnswer2: "",
            isNotExistUsername: false,
            isButtonLoading: false
        };

        componentDidMount() {
            this.textInputComponent?.element?.focus();
        }

        enableButton = () => {
            this.setState({
                canSubmit: true
            });
        };

        disableButton = () => {
            this.setState({
                canSubmit: false
            });
        };

        handleSubmit = (username, answer1, answer2, isVerifyUsername) => {
            this.setState({
                isButtonLoading: true,
                isNotExistUsername: false
            });

            $.ajax({
                url: flex.getApiUrl("/api/v1/auth/forgotpassword"),
                async: true,
                type: "POST",
                dataType: "json",
                data: JSON.stringify({ username, answer1, answer2, isVerifyUsername }),
                contentType: "application/json",
                headers: flex.getHeaders(),
                success: function (data) {
                    if (!this.unmounting) {
                        this.setState({
                            username: data?.username,
                            securityQuestion1: data?.securityQuestion1,
                            securityQuestion2: data?.securityQuestion2,
                            alertMsg: data.msg,
                            isNotExistUsername: data.isNotExistUsername,
                            isButtonLoading: false
                        }, () => {
                            this.textInputComponent?.element?.focus();
                        });
                    };
                }.bind(this),
                error: function (jqXHR, textStatus, errorThrown) {
                    flex.handleAjaxError(jqXHR, textStatus, errorThrown);
                    this.setState({
                        isButtonLoading: false,
                        isNotExistUsername: true,
                        alertMsg: jqXHR.responseJSON.msg || jqXHR.responseJSON.code,
                        isError: true
                    });
                }.bind(this)
            });
        };

        handleOnChangeFormsy = ({ username, answer1, answer2 }) => {
            this.setState({
                inputUsername: username,
                inputAnswer1: answer1,
                inputAnswer2: answer2
            });
        };

        onHandleIsPristineChange = () => {
            if (this.state.isPristine) {
                this.setState({ isPristine: false })
            }
        };

        handleResults = () => {
            const {
                username,
                securityQuestion1,
                securityQuestion2,
                inputAnswer1,
                inputAnswer2,
                inputUsername,
                isPristine,
                canSubmit,
                isButtonLoading
            } = this.state;
            const formProps = { layout: "vertical" };
            const usernameLabel = flex.text("UX_LOGIN_LBL_USERNAME", "Username");
            const yourAnswerLabel = flex.text("UX_FORGOTPASSWORD_LBL_YOURANSWER", "Type your answer");
            const invalidAnswerMsg = flex.text("UX_FORGOTPASSWORD_MSG_ANSWER_REQUIRED", "Answer is required");
            const invalidUsernameMsg = flex.text("UX_FORGOTPASSWORD_MSG_USERNAME_REQUIRED", "Username is required");

            return (
                <>
                    {username ?
                        <div className="forgotpassword__input-answer">
                            <div className="show-username">
                                <PrismIcon
                                    iconClassName="icon prism-icon-user"
                                ></PrismIcon>
                                <span className="show-username__text">{username}</span>
                            </div>
                            <div className="input-answer-one">
                                <label className="control-label" htmlFor="do-location">{securityQuestion1}</label>
                                <FormsyFields.Input
                                    {...formProps}
                                    id="answer1"
                                    name="answer1"
                                    labelClassName="sr-only"
                                    type="text"
                                    required
                                    placeholder={yourAnswerLabel}
                                    value={inputAnswer1}
                                    validationError={invalidAnswerMsg}
                                    onChange={this.onHandleIsPristineChange}
                                    onClick={(e) => { e.stopPropagation() }}
                                    componentRef={(node) => { this.textInputComponent = node; }}
                                />
                            </div>
                            <div className="input-answer-two">
                                <label className="control-label" htmlFor="do-location">{securityQuestion2}</label>
                                <FormsyFields.Input
                                    {...formProps}
                                    id="answer2"
                                    name="answer2"
                                    labelClassName="sr-only"
                                    type="text"
                                    required
                                    placeholder={yourAnswerLabel}
                                    value={inputAnswer2}
                                    validationError={invalidAnswerMsg}
                                />
                            </div>
                        </div>
                        : <div>
                            <div className="forgotpassword__input-username">
                                <FormsyFields.Input
                                    {...formProps}
                                    id="username"
                                    name="username"
                                    labelClassName="sr-only"
                                    type="text"
                                    placeholder={usernameLabel}
                                    value={inputUsername}
                                    required
                                    validationError={invalidUsernameMsg}
                                    isPristine={() => { return isPristine }}
                                    onChange={this.onHandleIsPristineChange}
                                    onClick={(e) => { e.stopPropagation() }}
                                    componentRef={(node) => { this.textInputComponent = node; }}
                                />
                                <PrismIcon
                                    className="forgotpassword__input-username_icon-user"
                                    iconClassName="icon prism-icon-user"
                                ></PrismIcon>
                            </div>
                        </div>}
                    <div className="forgotpassword__buttons-container form-group">
                        <div className="col-xs-6 forgotpassword__button-forgotusername forgotpassword--padding-none">
                            <Link to="/forgotusername" className="btn btn-cancel">{flex.text("UX_ACT_FORGOT_USERNAME", "Forgot Username")}</Link>
                        </div>
                        <div className="col-xs-2 forgotpassword__button-cancel forgotpassword--padding-none">
                            <a href="/" className="btn btn-cancel">{flex.text("UX_ACT_CANCEL", "Cancel")}</a>
                        </div>
                        <div className="col-xs-4 forgotpassword--padding-none">
                            {username ?
                                <LaddaButton
                                    color="primary"
                                    type="submit"
                                    className="btn"
                                    loading={isButtonLoading}
                                    disabled={!canSubmit || isButtonLoading}
                                    onClick={() => this.handleSubmit(username, inputAnswer1, inputAnswer2, false)}
                                >
                                    <span>{flex.text("UX_ACT_SUBMIT", "Submit")}</span>
                                </LaddaButton>
                                : <LaddaButton
                                    color="primary"
                                    type="button"
                                    className="btn"
                                    disabled={!canSubmit || isButtonLoading}
                                    loading={isButtonLoading}
                                    onClick={() => this.handleSubmit(inputUsername, null, null, true)}
                                >
                                    <span>{flex.text("UX_ACT_VERIFY", "Verify")}</span>
                                </LaddaButton>
                            }
                        </div>
                    </div>
                </>
            );
        };

        renderErrorMessage = (message, isError) => {
            message && setTimeout(() => flex.redirect(location.origin), 5000);

            const color = isError ? 'danger' : 'info';

            return message && (
                <>
                    <div className="forgotpassword__message-info">
                        <PrismMessage color={color}>
                            {message}
                        </PrismMessage>
                    </div>
                </>
            );
        };

        render() {
            const { alertMsg, isError, isNotExistUsername } = this.state;

            return (
                <div className="forgotpassword-container col-12">
                    <div className="forgotpassword">
                        <Formsy.Form
                            onValid={this.enableButton}
                            onInvalid={this.disableButton}
                            onChange={this.handleOnChangeFormsy}
                        >
                            <fieldset>
                                <h1 className="forgotpassword__title">
                                    {flex.text("UX_LOGIN_HDR_FORGOTPASSWORD", "Forgot Password")}
                                </h1>
                                {this.renderErrorMessage(alertMsg, isError)}
                                {!alertMsg &&
                                    <>
                                        <div className="forgotpassword__text-instruction">
                                            <span>Enter the requested information below.</span>
                                            <p>{flex.text("UX_CONTACT_CLIENT_CARE", "For assistance, please contact Client Care")}</p>
                                        </div>
                                        {this.handleResults()}
                                    </>
                                }
                            </fieldset>
                        </Formsy.Form>
                    </div>
                </div>
            );
        }
    }

    return ForgotPassword;
};

module.exports = initComponent;
